import {Link, makeChain} from "@Common/react/cst2";
import {consumeContext} from "src/loaders/consume-context";

export const NavigationService = ({renderChildren}:{
    renderChildren  : Link<JSX.Element, {
        goToOfficeAssets        : (options:{idBranch: string}) => Promise<void>,
        goToUserAssets          : (options:{idAgent: string, idBranch: string}) => Promise<void>,
    }>
}) => (
    makeChain<JSX.Element>()
    .then(...consumeContext("routerHistory"))
    .then(({routerHistory}) => renderChildren({
        goToOfficeAssets    : async ({idBranch}) =>
            routerHistory.push(`/account/admin/office/address-lists?office=${idBranch}`),
        goToUserAssets      : async ({idAgent, idBranch}) =>
            routerHistory.push(`/account/admin/user-assets?agent=${idAgent}&branch=${idBranch}`)
    }))
    .run()
);

